define('controllers/consoleApi/apiList.detail.ctrl',['app'], function (app) {
    app.controller('apiListDetailCtrl', ['$scope', '$q','$state','$rootScope','$stateParams','projectManageService','auiDialog','auiAgreementHelper',
        function ($scope, $q,$state,$rootScope,$stateParams,projectManageService,auiDialog,auiAgreementHelper) {
            var Model = $scope.Model = {
                userInfo:$scope.Model.userInfo
            };
            Model.projectKey=$stateParams.projectKey;
            Model.apiID=$stateParams.apiID;
            var agreementArray = [];
            var agreementTypes =[];
            Model.signedAgreeList=[];
            if(!Model.apiID || Model.apiID == 0){
                $state.go('apiList',{projectKey:Model.projectKey}, {reload: true});
            }
            projectManageService.setProjectKey(Model.projectKey);
            $scope.contains = AUI.BaseJSUtil.contains;
            $scope.callback = callback;
            $scope.closeApi =closeApi;
            $scope.openApi =openApi;
            $scope.clickApi = clickApi;
            $scope.clickHref = clickHref;
            $scope.addApiToPro = addApiToPro;
            $scope.showAgreement = showAgreement;
            function closeApi() {
                auiDialog.confirm("权限关闭","关闭API权限，API将无法使用，可能导致您应用异常，确定关闭吗？", function () {
                    projectManageService.delProjectAPI(Model.myProject.projectID,[Model.apiID]).then(function () {
                        $state.go($state.current.name, {projectKey:Model.projectKey,apiID:$stateParams.apiID}, {reload: true});
                    });
                });

            }
            
            function addApiToPro() {
                projectManageService.getProjectTotalCount().then(function (projectTotalCount) {
                    if(projectTotalCount == 0){
                        projectManageService.createProject().then(function (resp) {
                            projectManageService.setProjectKey(resp.projectKey);
                            $state.go('apiListDetail', {projectKey:resp.projectKey,apiID:Model.apiID});
                        });
                    }else{
                        projectManageService.managerPro({},$stateParams,Model);
                    }

                });
            }

            function openApi() {
                var defer = $q.defer();
                //检查隐私和开发者协议 没有签署就让他签
                auiAgreementHelper.checkAgreements(agreementArray, function () {
                    defer.resolve();
                }, $scope.Model.userInfo,true).then(function (res) {
                    if(res&& res.signed){
                        if(Model.apiInfo.isEnableTips == 1 && Model.apiInfo.langInfo.displayAttrs.enable_tips.display == "true"){
                            auiDialog.warn("权限开启",Model.apiInfo.langInfo.displayAttrs.enable_tips.tipTitle.replace('{0}', '<a class="text-link" href="' + Model.apiInfo.langInfo.displayAttrs.enable_tips.tipLinkUrl + '" target="_blank">').replace('{1}', '</a>'),{
                                "btnOK": "我知道了",
                                "hideClose": true
                            }, function () {
                                projectManageService.addProjectAPI(Model.myProject.projectID,[Model.apiID]).then(function () {
                                    $state.go($state.current.name, {projectKey:Model.projectKey,apiID:$stateParams.apiID}, {reload: true});
                                    defer.resolve();
                                });
                            },function () {
                                defer.resolve();
                            });
                        }else{
                            projectManageService.addProjectAPI(Model.myProject.projectID,[Model.apiID]).then(function () {
                                defer.resolve();
                                $state.go($state.current.name, {projectKey:Model.projectKey,apiID:$stateParams.apiID}, {reload: true});
                            });
                        }
                    }else{
                        defer.resolve();
                    }
                });
                return defer.promise;
            }

            init();

            function init() {
                if(Model.projectKey!='0'){
                    projectManageService.getProjectInfo({projectKey:Model.projectKey}).then(function (data) {
                        if(data && data.projectInfo){
                            Model.myProject = data.projectInfo;
                            projectManageService.setProjectKey(Model.myProject.projectKey);
                            projectManageService.getProjectAPI( Model.myProject.projectID).then(function (resp) {
                                Model.apiIDList=resp.apiIDList;
                                getApiDetail();
                            });
                        }
                    });
                }else{
                    getApiDetail();
                }


            }

            function callback() {
                $state.go('apiList', {projectKey:Model.projectKey});
            }
            function clickHref(url) {
                if(url){
                    window.open(url,"_blank");
                }
            }


            function getApiDetail() {
                projectManageService.getAPIDetail(Model.apiID).then(function (resp) {
                    Model.apiInfo = resp.apiDetail;
                    if(Model.apiInfo.langInfo && Model.apiInfo.langInfo.displayAttrs){
                        Model.apiInfo.langInfo.displayAttrs = angular.fromJson(Model.apiInfo.langInfo.displayAttrs);
                        if(Model.apiInfo.langInfo.displayAttrs.moreAPIs && Model.apiInfo.langInfo.displayAttrs.moreAPIs.apiList && Model.apiInfo.langInfo.displayAttrs.moreAPIs.apiList.length>0){
                            projectManageService.getApiListByIds(Model.apiInfo.langInfo.displayAttrs.moreAPIs.apiList).then(function (apiInfoTileList) {
                                Model.apiInfoTileList = apiInfoTileList;
                            })
                        }
                        if(Model.apiInfo.langInfo.displayAttrs &&Model.apiInfo.langInfo.displayAttrs.serviceterms
                            && Model.apiInfo.langInfo.displayAttrs.serviceterms.content && Model.apiInfo.langInfo.displayAttrs.serviceterms.content.length>0){
                            Model.apiInfo.langInfo.displayAttrs.serviceterms.content.forEach(function (agree) {
                                if(agree.agreementType){
                                    agreementArray.push({agrType: agree.agreementType, country: 'cn', count: 1});
                                    agreementTypes.push(agree.agreementType);
                                }
                            });
                            projectManageService.getIsSignAgreement(agreementTypes).then(function (res) {
                                if(res && res.signInfoList && res.signInfoList.length>0){
                                    res.signInfoList.forEach(function (signInfo) {
                                        if((signInfo.signStatus ==1 || signInfo.signStatus == 2)){
                                            Model.signedAgreeList.push(signInfo.agrType);
                                        }
                                    });
                                }
                            });
                        }
                        if(Model.apiIDList && AUI.BaseJSUtil.contains(Model.apiIDList,Model.apiInfo.apiID)){
                            //检查隐私和开发者协议 没有签署就让他签
                            auiAgreementHelper.checkAgreements(agreementArray, callback, $scope.Model.userInfo,true).then(function () {
                            });
                        }
                    }
                });
            }

            function clickApi(apiInfo) {
                $state.go('apiListDetail', {projectKey:Model.projectKey,apiID:apiInfo.langInfo.apiID});
            }

            function showAgreement(){
                var defer = $q.defer();
                auiAgreementHelper.viewAndDownloadAgreements(Model.signedAgreeList).then(function () {
                    defer.resolve();
                }).catch(function () {
                    defer.reject();
                });
                return defer.promise;
            }


        }
    ]);
});

